// import Chart from "react-apexcharts";
// import React from "react";
// import { transformChartData } from "../charthelper";

// const MixedChart = ({ chartUtils, chartinfo, colors }) => {
//   if (!chartUtils || typeof chartUtils !== "object") {
//     return <div>Loading chart...</div>;
//   }
//   const categories =
//     Array.isArray(chartUtils?.category) && chartUtils.category.length > 0
//       ? chartUtils.category
//       : ["No Data"];

//   const seriesColors = Array.isArray(chartUtils?.series)
//     ? chartUtils.series.map((s) => chartUtils.colors?.[s?.name] || "#999")
//     : ["#999"];

//   const safeSeries = Array.isArray(chartUtils?.series)
//     ? chartUtils.series
//       .filter((s) => s && typeof s === "object")
//       .map((s) => ({
//         name: s?.name || "Unnamed Series",
//         data: Array.isArray(s?.data) && s.data.length > 0 ? s.data : [0],
//         type: s?.type || "line",
//       }))
//     : [];
//   const yAxisConfig = [
//     {
//       title: {
//         text: chartUtils?.axis?.y || "Y-Axis (Value)",
//         style: {
//           fontSize: "14px",
//           fontWeight: "bold",
//           color: "#333",
//         },
//       },
//       labels: {
//         formatter: (value) =>
//           typeof value === "number" ? value.toFixed(2) : "0",
//       },
//     },
//     {
//       opposite: true,
//       title: {
//         text: chartUtils?.axis?.z || "Z-Axis (Size/Depth)",
//         style: {
//           fontSize: "14px",
//           fontWeight: "bold",
//           color: "#333",
//         },
//       },
//     },
//   ];

//   const options = {
//     chart: {
//       type: "line",
//       stacked: chartUtils?.options?.stacked ?? false,
//     },
//     xaxis: {
//       categories,
//       title: { text: chartUtils?.axis?.x || "X-Axis" },
//     },

//     yaxis: yAxisConfig,
//     colors: seriesColors,
//     legend: {
//       show: true,
//       position: "top",
//       horizontalAlign: "center",
//       fontSize: "12px",
//       fontWeight: 600,
//       labels: {
//         colors: "#333",
//       },

//       markers: {
//         size: 0,
//       },
//       itemMargin: {
//         horizontal: 10,
//         vertical: 5,
//       },
//     },
//     fill: {
//       type: ["gradient", "solid", "solid"],
//       gradient: {
//         inverseColors: false,
//         shade: "light",
//         type: "vertical",
//         shadeIntensity: 0.5,
//         opacityFrom: 0.8,
//         opacityTo: 0.3,
//         stops: [0, 100, 100, 100],
//       },
//     },
//     plotOptions: {
//       bar: {
//         columnWidth: "50%",
//       },
//     },
//     stroke: { width: [3, 3, 2], curve: "smooth" },
//   };

//   if (!safeSeries.length || !categories.length) {
//     return <div>No chart data available.</div>;
//   }
//   console.log("safeSeriessafeSeries", transformChartData(categories, safeSeries))
  

//   console.log("transformChartData(categories, safeSeries)",safeSeries)
//   return chartUtils?.chart_type === "MIXEDCHART" ? (
//     <Chart
//       options={options}
//       series={transformChartData(categories,safeSeries)}
//       type="line"
//       height={350}
//       width={"100%"}
//     />
//   ) : (
//     ""
//   );
// };

// export default MixedChart;

import Chart from "react-apexcharts";
import React from "react";
import { transformChartData } from "../charthelper";

const MixedChart = ({ chartUtils, chartinfo, colors }) => {
  if (!chartUtils || typeof chartUtils !== "object") {
    return <div>Loading chart...</div>;
  }
  
  const categories =
    Array.isArray(chartUtils?.category) && chartUtils.category.length > 0
      ? chartUtils.category
      : ["No Data"];

  const seriesColors = Array.isArray(chartUtils?.series)
    ? chartUtils.series.map((s) => chartUtils.colors?.[s?.name] || "#999")
    : ["#999"];

  const safeSeries = Array.isArray(chartUtils?.series)
    ? chartUtils.series
      .filter((s) => s && typeof s === "object")
      .map((s) => ({
        name: s?.name || "Unnamed Series",
        data: Array.isArray(s?.data) && s.data.length > 0 ? s.data : [0],
        type: s?.type || "line",
      }))
    : [];

  const yAxisConfig = [
    {
      title: {
        text: chartUtils?.axis?.y || "Y-Axis (Value)",
        style: {
          fontSize: "14px",
          fontWeight: "bold",
          color: "#333",
        },
      },
      labels: {
        formatter: (value) =>
          typeof value === "number" ? value.toFixed(2) : "0",
      },
    },
    {
      opposite: true,
      title: {
        text: chartUtils?.axis?.z || "Z-Axis (Size/Depth)",
        style: {
          fontSize: "14px",
          fontWeight: "bold",
          color: "#333",
        },
      },
      labels: {
        formatter: (value) =>
          typeof value === "number" ? value.toFixed(2) : "0",
      },
    },
  ];

  const options = {
    chart: {
      type: "line",
      stacked: chartUtils?.options?.stacked ?? false,
    },
    xaxis: {
      type: "datetime",
      title: { text: chartUtils?.axis?.x || "X-Axis" },
    },
    yaxis: yAxisConfig,
    colors: seriesColors,
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "center",
      fontSize: "12px",
      fontWeight: 600,
      labels: {
        colors: "#333",
      },
      markers: {
        size: 6,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 5,
      },
    },
    fill: {
      type: ["gradient", "solid", "solid"],
      gradient: {
        inverseColors: false,
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.5,
        opacityFrom: 0.8,
        opacityTo: 0.3,
        stops: [0, 100, 100, 100],
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "50%",
      },
    },
    stroke: { width: [3, 3, 2], curve: "smooth" },
  };

  if (!safeSeries.length || !categories.length) {
    return <div>No chart data available.</div>;
  }

  console.log("safeSeries", safeSeries);
  console.log("transformChartData result", transformChartData(categories, safeSeries));

  return chartUtils?.chart_type === "MIXEDCHART" ? (
    <Chart
      options={options}
      series={transformChartData(categories, safeSeries)}
      type="line"
      height={350}
      width={"100%"}
    />
  ) : (
    ""
  );
};

export default MixedChart;